import React, { useEffect, useMemo, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { ApexOptions } from "apexcharts";
import axiosInstance from "../../utils/axiosConfig";
import { API_URL } from "../../constant";
import { useAuth } from "../../context/auth-context";

const UsersGraph = () => {
  const { isAuthenticated } = useAuth();
  const [users, setUsers] = useState<any[]>([]);
  const [clients, setClients] = useState<any[]>([]);

  const currentDate = new Date();
  const currentMonth = currentDate.getMonth(); // Get the current month (0-indexed)

  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sept",
    "Oct",
    "Nov",
    "Dec",
  ];

  const xAxisCategories = months.slice(0, currentMonth + 1);
  const returnMonthData = (arr: any[]) => {
    const emptyArr = Array(12).fill(0);

    for (let i = 1; i <= emptyArr.length; i++) {
      const monthItem = arr.find(
        (item: { _id: { month: number } }) => item._id.month === i
      );
      emptyArr[i - 1] = monthItem ? monthItem.totalActive : 0;
    }

    return emptyArr;
  };
  const returnClientMonthData = (arr: any[]) => {
    const emptyArr = Array(12).fill(0);

    for (let i = 1; i <= emptyArr.length; i++) {
      const monthItem = arr.find(
        (item: { _id: { month: number } }) => item._id.month === i
      );
      emptyArr[i - 1] = monthItem ? monthItem.total : 0;
    }

    return emptyArr;
  };

  useEffect(() => {
    setTimeout(() => {
      axiosInstance
        .get(`${API_URL}api/stats/graph-data/GROWTH/YEAR?userType=basic-user`)
        .then((r: any) => {
          setUsers(r.data.data);
        })
        .catch((e: any) => {
          console.log(e.response.data.message);
        });
    }, 2000);
  }, [isAuthenticated]);
  useEffect(() => {
    setTimeout(() => {
      axiosInstance
        .get(`${API_URL}api/stats/graph-data/GROWTH/YEAR?userType=client`)
        .then((r: any) => {
          setClients(r.data.data);
        })
        .catch((e: any) => {
          console.log(e.response.data.message);
        });
    }, 2000);
  }, [isAuthenticated]);

  const chartData = useMemo(
    () => ({
      series: [
        {
          name: "Users",
          data: returnMonthData(users).slice(0, currentMonth + 1),
          color: "#2385DF",
        },
        {
          name: "Clients",
          data: returnClientMonthData(clients).slice(0, currentMonth + 1),
          color: "#9DD0FF",
        },
      ],
      options: {
        chart: {
          type: "bar",
          height: 325,
          stacked: true,
        },
        dataLabels: {
          enabled: false,
        },
        tooltip: {
          shared: true,
          intersect: false,
          theme: "dark",
          // y: {
          //   formatter: function (val: any) {
          //     return val;
          //   },
          // },
        },
        stroke: {
          curve: "smooth",
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              legend: {
                position: "bottom",
                offsetX: -10,
                offsetY: 0,
              },
            },
          },
        ],
        xaxis: {
          type: "category",
          categories: xAxisCategories,
          tickAmount: 12, // Show all 12 months on the x-axis
          labels: {
            style: {
              fontSize: "12px", // Adjust font size
              fontFamily: "Manrope, sans-serif", // Change font family
              fontWeight: "normal", // Set font weight
              colors: "#617889", // Set font color
            },
          },
        },
        yaxis: {
          labels: {
            style: {
              fontSize: "12px", // Adjust font size
              fontFamily: "Manrope, sans-serif", // Change font family
              fontWeight: "normal", // Set font weight
              colors: "#617889", // Set font color
            },
          },
          min: 0,
          max:
            Math.max(
              ...returnMonthData(users),
              ...returnClientMonthData(clients)
            ) + 5,
          stepSize: 10,
        },
        fill: {
          opacity: 1,
        },
        legend: {
          position: "bottom",
          offsetX: 0,
          offsetY: 0,
          fontSize: "12px",
          fontFamily: "Manrope, sans-serif",
          fontWeight: 500,
          labels: {
            colors: "#617889",
            useSeriesColors: false,
          },
        },

        grid: {
          show: false, // Remove the horizontal and vertical grid lines
        },
      },
    }),
    [users, currentMonth, clients, xAxisCategories]
  );
  return (
    <div id="chart" className="w-full">
      <ReactApexChart
        options={chartData.options as ApexOptions}
        series={chartData.series}
        type="bar"
        height={325}
      />
    </div>
  );
};

export default UsersGraph;
